import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

export class InventoryFetchAPI {

    static async receiveInventory(data, token) {
        const res = await server(`/inventory/receive`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async sendInventory(data, token) {
        const res = await server(`/inventory/send`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async sendInventory(data, token) {
        const res = await server(`/inventory/send`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async transferInventory(data, token) {
        const res = await server(`/inventory/transfer`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async getInventoryBywarehouse(warehouse_id, token) {
        const res = await server(`/inventory/warehouse/${warehouse_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async getInventoryMovements(warehouse_id, token, status, initialDate, maxDate) {
        let url = `/inventory/movements?warehouse_id=${warehouse_id}`
        //We add the status and type transfer
        if (status != undefined) {
            url = url + `&status=${status}&type=transfer`
        }
        //We add the initial
        if (initialDate != undefined) {
            url = url + `&initialDate=${initialDate}`
        }
        //We add the max date
        if (maxDate != undefined) {
            url = url + `&maxDate=${maxDate}`
        }

        //We make the request
        const res = await server(url, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async Updatetransferinventorymovement(token, data) {
        const res = await server(`/inventory/transfer`, {
            method: "put",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async downloandInventoryReport(warehouse_id, token, initialDate, maxDate) {
        try {
            const res = await server(`/excel/download/inventory/report?warehouse_id=${warehouse_id}&initialDate=${initialDate}&maxDate=${maxDate}`, {
                method: "post",
                headers: {
                    'x-access-token': token,
                    "Content-Type": "application/json"
                },
                responseType: "blob"
            });
            //We create a link to download the file
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "inventory_report.xlsx"); // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            return true
        } catch (err) {
            console.log("Error downloading the file", err);
            return false
        }

    }

}
